import { styled } from '@mui/material/styles';
import { IconButton, Autocomplete, Box } from '@mui/material';

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  right: 8,
  top: 8,
  color: "#000"
});

export const GroupAutocomplete = styled(Autocomplete)({
  marginTop: "8px"
});

export const SectionContainer = styled('section')({
  background: "white",
  width: "100%"
});

export const DropzoneContainer = styled('div')({
  flex: "1",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "20px",
  padding: "20px",
  border: "2px dashed #3098ff",
  borderRadius: "2px",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out"
});

export const LoadingContainer = styled(Box)({
  width: "100%",
  marginTop: "16px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
});

export const UploadingFilesContainer = styled(Box)({
  marginTop: "16px"
});

export const UploadingFileItem = styled(Box)({
  backgroundColor: "#f3f5f7",
  borderRadius: "8px",
  marginBottom: "16px",
  padding: "8px"
});

export const FileItemContent = styled(Box)({
  display: "flex",
  flexDirection: "column"
});

export const FileItemRow = styled(Box)({
  display: "flex",
  flexDirection: "row"
});

export const FileNameContainer = styled(Box)({
  flex: 2,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: "#000"
});

export const FileStatusContainer = styled(Box)({
  flex: 1
});

export const WaitingStatus = styled(Box)({
  color: "#4b4b4b",
  textAlign: "end"
});

export const UploadingStatus = styled(Box)({
  color: "#000",
  textAlign: "end"
});

export const SuccessStatus = styled(Box)({
  color: "#67d267",
  textAlign: "end"
});

export const FailedStatus = styled(Box)({
  color: "#e15e5e",
  textAlign: "end"
});

export const ProgressContainer = styled(Box)({
  width: "100%",
  height: "8px",
  backgroundColor: "#fff",
  borderRadius: "20px",
  marginTop: "16px"
});

export const ProgressBar = styled(Box)<{ progress: number }>(({ progress }) => ({
  width: `${progress}%`,
  height: "100%",
  backgroundColor: "#3098ff",
  borderRadius: "inherit"
})); 